import React, { PureComponent } from 'react';
import Shortid from 'shortid';
import MenuCategory from './MenuCategory';

import './menu.styl';

class Menu extends PureComponent {
  render() {
    const MenuCategories = this.props.items.map(item => {
      return <MenuCategory key={Shortid.generate()} dispatch={this.props.dispatch} activeItem={this.props.activeItem} items={item.groups} title={item.cat}/>
    });

    return (
      <div className="ifdw-menu--wrapper">
        {MenuCategories}
      </div>
    );

  }
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./src/components/Menu/index.js
 **/